import authApi from '@/api/auth'

const state = {
  currentUser: { init: true }
}

const mutations = {
  setCurrentUser(state, value) {
    state.currentUser = value
  }
}

const actions = {
  getCurrentUser ({commit}) {
    return authApi.getCurrentUser()
      .then(res => {
        commit('setCurrentUser', res.data.data)
        return res
      })
      .catch(i => i)
  },
  login ({commit}, { data }) {
    return authApi.login(data)
      .then(res => {
        commit('setCurrentUser', res.data.data)
        return res
      })
      .catch(i => i)
  },
  logout ({commit}) {
    return authApi.logout()
      .then( res => {
        commit('setCurrentUser', {})
        return res
      })
      .catch(i => i)
  }
}

const getters = {
  currentUser: state => state.currentUser || {},
  isLoggedIn: (state, getters) => !!getters.currentUser.username
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
